import { render, staticRenderFns } from "./ApplicationForPayments.vue?vue&type=template&id=2bd7eaa6&"
import script from "./ApplicationForPayments.vue?vue&type=script&lang=js&"
export * from "./ApplicationForPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports